/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateSprintGoalInput = {
    id?: string | null | undefined;
    description?: string | null | undefined;
    stage?: string | null | undefined;
    done?: boolean | null | undefined;
    statusColor?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UpdateSprintGoalMutationVariables = {
    input: UpdateSprintGoalInput;
};
export type UpdateSprintGoalMutationResponse = {
    readonly updateSprintGoal: {
        readonly sprintGoal: {
            readonly id: string;
            readonly description: string | null;
            readonly stage: string | null;
            readonly statusColor: string | null;
        } | null;
    } | null;
};
export type UpdateSprintGoalMutation = {
    readonly response: UpdateSprintGoalMutationResponse;
    readonly variables: UpdateSprintGoalMutationVariables;
};



/*
mutation UpdateSprintGoalMutation(
  $input: UpdateSprintGoalInput!
) {
  updateSprintGoal(input: $input) {
    sprintGoal {
      id
      description
      stage
      statusColor
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateSprintGoalInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSprintGoalPayload",
    "kind": "LinkedField",
    "name": "updateSprintGoal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SprintGoal",
        "kind": "LinkedField",
        "name": "sprintGoal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "statusColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateSprintGoalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateSprintGoalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateSprintGoalMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateSprintGoalMutation(\n  $input: UpdateSprintGoalInput!\n) {\n  updateSprintGoal(input: $input) {\n    sprintGoal {\n      id\n      description\n      stage\n      statusColor\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '70a8db7ea3f16828032e84f838911262';
export default node;
